import { Component, Input } from '@angular/core';

type LoadingSize = 'sm' | 'md' | 'lg';

@Component({
  selector: 'app-loading',
  standalone: true,
  styles: [`
    .overlay {
      position: absolute;
      inset: 0;
      z-index: 50;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(0, 0, 0, .1);
      backdrop-filter: blur(4px);
    }

    .spinner {
      border: 2px solid transparent;
      border-top-color: currentColor;
      border-left-color: currentColor;
      border-radius: 999px;
      animation: spin .6s linear infinite;
    }

    .sm { width: 24px; height: 24px; }
    .md { width: 40px; height: 40px; }
    .lg { width: 56px; height: 56px; }

    @keyframes spin { to { transform: rotate(360deg); } }
  `],
  template: `
    <div role="status" aria-busy="true" class="overlay">
      <div class="spinner" [class]="size"></div>
      <span class="sr-only">Loading</span>
    </div>
  `,
})
export class LoadingComponent {
  @Input() size: LoadingSize = 'md';
}
